import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDirection2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="direction-2, route"><path d="M12 9V3.75H19.25L21.25 6.5L19.25 9H12ZM12 9V14M12 9H4.75L2.75 11.5L4.75 14H12M12 14V20.25M12 20.25H7.75M12 20.25H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDirection2;
